import {Layout, Tabs} from "antd";
import TagManager from "../../TagManager/TagManager";
import ModelTraining from "../ModelTraining/ModelTraining";
import TestModel from "../TestModel/TestModel";
import ConfigEditor from "../../ConfigEditor/ConfigEditor";
import ProfilesTab from "../../ConfigEditor/ProfilesTab";
import React, {useContext, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AuthContext} from "../../Auth/AuthProvider";
import {getConfig, getModels, getTags} from "../../util/redux/asyncActions";
import {WORKFLOW_STEPS} from "../../util/constants";
import AppHeader from "../../AppHeader/AppHeader";

const {Content} = Layout;

const MlTraining = () => {
    // remember the open step so a page refresh doesn't jump back to the first tab
    const [activeTab, setActiveTabState] = useState(() => localStorage.getItem("sc.tab.mltraining") || "0");
    const setActiveTab = (k) => {
        setActiveTabState(String(k));
        try { localStorage.setItem("sc.tab.mltraining", String(k)); } catch (e) { /* storage unavailable */ }
    };
    const dispatch = useDispatch();
    const userManager = useContext(AuthContext);
    const config = useSelector(state => state.request.config);
    const models = useSelector(state => state.request.models);
    const allEntities = useSelector(state => state.request.all_entities);

    useEffect(() => {
        if (config === undefined) dispatch(getConfig({userManager}));
        if (!models || models.length === 0) dispatch(getModels({userManager}));
        if (!allEntities || allEntities.length === 0) dispatch(getTags({userManager}));
    }, []);

    const tabItems = [
        {label: "Tags", key: "0", children: <TagManager/>},
        {label: "Model Training", key: "1", children: <ModelTraining/>},
        {label: "Configure", key: "2", children: <ConfigEditor/>},
        {label: "Profiles", key: "3", children: <ProfilesTab/>},
        {label: "Test Model", key: "4", children: <TestModel/>},
    ];

    const currentStep = parseInt(activeTab);

    return (
        <Layout style={{minHeight: "100vh", background: "var(--sc-ground)"}}>
            {/* App header with area switch */}
            <AppHeader area="mltraining"/>

            {/* Tab content */}
            <Content style={{padding: 0}}>
                <div className="sc-page">
                    {/* Workflow stepper — calm, guided setup */}
                    <div className="sc-stepper" style={{marginBottom: 24}}>
                        {WORKFLOW_STEPS.map((step, i) => (
                            <button
                                key={step.key}
                                type="button"
                                className={"sc-step" + (i < currentStep ? " done" : i === currentStep ? " active" : "")}
                                onClick={() => setActiveTab(String(i))}
                                aria-current={i === currentStep ? "step" : undefined}
                            >
                                <span className="num">{i < currentStep ? "✓" : i + 1}</span>
                                <span className="t">{step.title}<small>{step.description}</small></span>
                            </button>
                        ))}
                    </div>

                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        centered
                        items={tabItems}
                        tabBarStyle={{display: "none"}}
                    />
                </div>
            </Content>
        </Layout>
    );
};

export default MlTraining;
